import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import $ from '../node_modules/jquery/dist/jquery';
import reportWebVitals from './reportWebVitals';
import 'bootstrap-icons/font/bootstrap-icons.css';

window.fileMgtCallback = null;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

function IconButton(props) {
    return <button type='button' className="btn btn-default" onClick={() => { props.onClick() }}><img height='32px' src={"/Icons/" + props.icon + ".png"}></img></button>
}


export class FileMgt extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = { path: '/', items: [] };
        this.paths = ['/'];
        this.relist = this.relist.bind(this);
        this.startUpload = this.startUpload.bind(this);
        window.refList = this.relist;
    }
    Ajax(controller, action, data, funcOk, funcFail, showMessage = true) {
        let thisCmd = this;
        $('#AjaxStatus').show();
        let token = localStorage.getItem('token');
        $.ajax('/' + controller + "/" + action
            , {
                method: 'POST', dataType: "json", headers: (token == null ? {} : {
                    Authorization: 'Bearer ' + token
                }), data: data, success: function (data) { $('#AjaxStatus').hide(); funcOk(data); }
                , error: function (err) {
                    $('#AjaxStatus').hide();
                    if (showMessage) {
                        if (err.status == 401) {
                            let ic = 0;


                          alert('نیاز به ورود مجددا می باشد')
                            window.goToLink('LoginLink');

                            window.menu = null;
                            window.menu2 = null;
                        }
                        else if (err.status == 500) {
                            
                           alert('خطا داخلی رخ داد')
                        }
                        else if (err.status == 403) {
                          //  thisCmd.MessageBox(FixedMessage.NotPermited, FixedMessage.Result);
                            alert('شما دسترسی ندارید')
                        }
                        else if (err.status == 404) {
                            //  thisCmd.MessageBox(FixedMessage.Err404, FixedMessage.Result);
                            alert('صفحه مورد نظر پیاده سازی نشده')
                        }
                        else {
                            funcFail(err);
                        }
                    }
                    else {
                        funcFail(err);
                    }
                }


            });
    }

    relist() {
        let cmd = this;
        this.Ajax('FileMgt', 'List', { path: this.state.path },   (data)=>{
            let dat = cmd.state;
            dat.items = data;
            cmd.setState(dat);
           
        });
    }
    componentDidMount() {
        this.relist();
    }

    AjaxForUpload(controller, action, data, funcOk, funcFail, showMessage = true) {

        let thisCmd = this;
        $('#AjaxStatus').show();

        $('.Progr').show();
        let token = localStorage.getItem('token');
        $.ajax('/' + controller + "/" + action
            , {
                type: 'POST', dataType: "json", headers: (token == null ? {} : {
                    Authorization: 'Bearer ' + token
                }), data: data,

                xhr: function () {
                    let xhr = new XMLHttpRequest();
                    if (xhr.upload) {
                        xhr.upload.onprogress = function (e) {
                            if (e.lengthComputable) {
                                let pos = e.loaded || e.position;
                                console.log(pos / e.total * 100);
                                let per = (pos / e.total) * 100;
                                $('.progress-bar').html(per + '%');
                                $('.progress-bar').css('width', per + '%');
                                $('.progress-bar').attr('aria-valuenow', per);

                            }
                        };
                    }
                    return xhr;
                }

                , processData: false, contentType: false, success: function (data) { $('.Progr').hide(); $('#AjaxStatus').hide(); funcOk(data); }
                , error: function (err) {
                    $('.Progr').hide();
                    $('#AjaxStatus').hide();
                    if (showMessage) {
                        if (err.status == 401) {
                            alert('نیاز به ورود مجدد');
                            setTimeout(
                                function
                                    () {
                                    window.reload();
                                }, 3000
                            );
                        }
                        else if (err.status == 500) {
                          alert('خطا داخلی')
                            funcFail(err);
                        }
                        else if (err.status == 403) {
                            alert('عدم دسترسی');
                        }
                        else if (err.status == 404) {
                            alert('یافت نشد');
                        }
                        else {
                            funcFail(err);
                        }
                    }
                    else {
                        funcFail(err);
                    }
                }


            });


    }

    startUpload() {
        let formData = new FormData();
        let cx = document.getElementById('txtFiles');
        if (cx.files.length == 0) {
            alert('فایلی انتخاب نشده');

        }
        formData.append('path', this.state.path);
        for (let i = 0; i < cx.files.length; i++) {
            formData.append('file', cx.files[i], cx.files[i].value);
        }
        let cmd = this;
        this.AjaxForUpload('FileMgt', 'Upload', formData, function (data) {

            alert(data.message);
            cmd.relist();
        });

    }


    render() {

         
      
         

        return <form key={Math.random()} className="row g-3" ><AjaxStatus />
            <div className="col-sm-12">
                مسیر فعلی :  {this.state.path}
                

                <hr />
                <IconButton onClick={() => { this.relist() }} icon="ref" />
                <IconButton onClick={() => {
                    if (this.paths.length == 1) {
                        return;
                    }
                    this.paths.pop();
                    let i = this.state;
                    i.path = this.paths[this.paths.length - 1];
                    this.setState(i);
                    this.relist()
                }} icon="back" />
                <IconButton icon="New" onClick={() => {
                    $('#upload').toggle(500);
                }} />
                <IconButton icon="Folder" onClick={() => {
                    $('#createFolder').toggle(500);
                }} />
                <IconButton icon="Delete" onClick={() => {
                    $('#Delete').toggle(500);
                }} />
                <IconButton icon="Rename" onClick={() => {
                    $('#Rename').toggle(500);
                    $('#txtNewFile').val(this.selectItem.name);
                }} />
                <IconButton icon="Unit" onClick={() => {
                    let c = this.state;
                    for (let i = 0; i < c.items.length; i++) {
                        c.items[i].selectable = true;
                    }
                    this.setState(c);
                }} />
                {window.fileMgtCallback != null && < IconButton icon="Yes" onClick={() => {
                    let targets = [];
                    for (let i = 0; i < this.state.items.length; i++) {
                        if (this.state.items[i].selectable.toString() == 'true') {
                            targets.push(this.state.items[i]);
                        }

                    }
                    window.fileMgtCallback(targets);
                    window.close();
                }} />}
                {window.fileMgtCallback != null && < IconButton icon="No" onClick={() => {
                    
                    window.close();
                }} />}
                <hr />

                <div id="upload" style={{ display:'none' }} >
                    <input id="txtFiles" type="file" multiple></input>
                    <button className="btn btn-default" type="button" onClick={this.startUpload }  >ارسال</button>
                   
                </div>
                <div id="createFolder" style={{ display: 'none' }} >
                    نام پوشه<input id="txtFolderName" type="text" className="form-control" multiple></input>
                    <button className="btn btn-default" type="button" onClick={() => {
                        let na = $('#txtFolderName').val();
                        let cmd = this;
                        if (na != '') {
                            this.Ajax('FileMgt', 'CreateFolder', { path: this.state.path, name: na }, function (data) {
                                alert(data.message);
                                cmd.relist();

                            });
                        }

                    }}  >ایجاد</button>

                </div>
                <div id="Rename" style={{ display: 'none' }} >
                    نام جدید<input id="txtNewFile" type="text" className="form-control" multiple></input>
                    <button className="btn btn-default" type="button" onClick={() => {
                        let na = $('#txtNewFile').val();
                        let cmd = this;
                        if (na != '') {
                            this.Ajax('FileMgt', 'Rename', { path: this.selectItem.fullName, name: na, type: this.selectItem.type }, function (data) {
                                alert(data.message);
                                cmd.relist();

                            });
                        }

                    }}  >تغییر نام</button>

                </div>



                <div id="Delete" style={{ display:'none' }} >
                    <button className="btn btn-default" type="button" onClick={() => {
                        let z = [];
                        let t = [];
                        for (let i = 0; i < this.state.items.length; i++) {
                            if (this.state.items[i].selectable.toString() == 'true') {
                                z.push(this.state.items[i].fullName);
                                t.push(this.state.items[i].type);
                            }
                         
                        }
                        let cmd = this;
                        this.Ajax('FileMgt', 'Delete', { filenames: z  ,types:t}, function (data) {
                            alert(data.message);
                            cmd.relist();
                        });
                    }} >حذف کن </button>
                </div>
                <label id="txtMessage" />
            </div>
       
            {this.state.items.map((v) => {
                return <div key={Math.random()} className="col-sm-1" onDoubleClick={() => {
                   
                    if (v.type == 'Folder') {
                        
                    }
                }}  style={{ borderRadius: '3px', position: 'relative', margin: '5px', cursor: 'pointer', background: (v.selectable == true ? '#84e2ff' : 'transpert') }}>
                    <center>
                        <span type="button" onClick={() => {
                            v.selectable = v.selectable.toString() == 'true' ? false : true;
                            this.selectItem = v;
                            $('#txtNewName').val(v.name);
                            this.setState(this.state);
                        }}  ><img src={v.selectable ? "/Icons/Yes.png" : "/Icons/No.png"} width='24px' ></img> </span> <br />
                        {v.type == "Folder" && <i onClick={
                            () => {
                                let s = this.state;
                                s.path = v.fullName;
                                this.paths.push(v.fullName);
                                this.setState(s);
                                this.relist();
                            }

                        } style={{ fontSize: '48px' }} className="bi-folder"></i>}
                        <br />
                        {v.type == "File" && v.exe != '.png' && v.exe != '.jpg' && <a target="_blank" href={'/content' + v.fullName.substring(0, v.fullName.length - 1)}> < i style={{ fontSize: '48px' }} className="bi-file"></i></a>}
                        {v.type == "File" && (v.exe == '.png' || v.exe == '.jpg') && <a target="_blank" href={'/content' + v.fullName.substring(0, v.fullName.length - 1)}> <img width="48px" height="48px" src={'/content' + v.fullName.substring(0, v.fullName.length - 1)} /> </a>}

                        <br />
                        {v.type == "File" && v.exe!='.png' && v.exe!='.jpg' && <span style={{ fontSize: '24px', position: 'absolute', right: '40%', background:'green', top: '48px' }} >{v.exe}</span>}
                        {v.name} <br />
                      
                        </center>
                    </div>;

                })}
        


        </form>
    }

}



const root = ReactDOM.createRoot(document.getElementById('root'));
if (window.location.toString().indexOf('Home') != -1) {
    root.render(

        <FileMgt />

    );
}
function AjaxStatus(props) {
    return <div id='AjaxStatus' style={{ position: 'fixed', left: '0px', bottom: '0px', display: 'none' }}>
        <LoadingBar />  لطفا صبر کنید
    </div>

}
function LoadingBar() {
    return <div className="spinner-grow text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
    </div>
}